import { render, staticRenderFns } from "./chargeback.vue?vue&type=template&id=4fc3e02f&scoped=true&"
import script from "./chargeback.vue?vue&type=script&lang=js&"
export * from "./chargeback.vue?vue&type=script&lang=js&"
import style0 from "./chargeback.vue?vue&type=style&index=0&id=4fc3e02f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc3e02f",
  null
  
)

export default component.exports